import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as faqApi from '../../../api/faq';
import { CreateFaqModel } from '../../../types/Endpoints/faq/FaqContracts';
import { Thunk } from '../../../helpers/redux/Thunk';
import { addNotification } from '../../notifications/addNotification';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { TypesIcon } from '../../../types/TypesIcon';
import { getFaqList } from './getFaqList';

export const CREATE_FAQ = 'faq/createFaq';

const onSuccess = (): Thunk => async (dispatch, getState) => {
    const { lastListParams } = getState().faq;

    if (lastListParams) {
        await dispatch(getFaqList(lastListParams));
    }

    dispatch(addNotification({
        type: TypesSnackbars.SUCCESS,
        message: {
            title: 'Изменения сохранены',
            description: '',
        },
        icon: TypesIcon.SNACK_SUCCES,
    }));
};

export const createFaq = createAsyncThunk(
    CREATE_FAQ,
    createRequest({
        type: CREATE_FAQ,
        loader: async (requestData: CreateFaqModel) => faqApi.createFaq(requestData),
        onSuccess,
    }),
);
